import { render, staticRenderFns } from "./sms_view.vue?vue&type=template&id=0db378a1&scoped=true&"
import script from "./sms_view.vue?vue&type=script&lang=js&"
export * from "./sms_view.vue?vue&type=script&lang=js&"
import style0 from "./sms_view.vue?vue&type=style&index=0&id=0db378a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db378a1",
  null
  
)

export default component.exports